import { configs } from "@/configs";
import cachedLocalStorage from "@/libs/localStorage";
import { useAuth } from "@/provider/UserProvider";
import axios from "axios";
import { useSearchParams } from "next/navigation";
import { useEffect } from "react";

const useLoginWithToken = () => {
  const searchParams = useSearchParams();
  const { setAuth } = useAuth();
  const token = searchParams.get('token');
  const tokenExpiry = searchParams.get('token_expiry');
  const refreshToken = searchParams.get('refresh_token');
  const refreshTokenExpiry = searchParams.get('refresh_token_expiry');
  const isOwalletParam = searchParams.get('isowallet');

  const accessTokenStr = typeof window !== 'undefined' ? cachedLocalStorage.getWithExpiry('token') : null;
  const refreshTokenStr = typeof window !== 'undefined' ? cachedLocalStorage.getWithExpiry('refreshToken') : null;

  const handleGetInfoUser = async () => {
    const res = await axios.get('/providers/me/profile', {
      baseURL: configs.baseURL,
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });
    const info = res.data;
    if (info) {
      setAuth(prev => ({ 
        ...prev,
        user: {
          ...prev.user,
          id: info.id,
          username: info.username,
          picture: info.picture,
          publicAddress: info.publicAddress,
          description: info.description ?? '',
          email: info?.email ?? '',
          refCode: info.refCode,
          sVerify: info.sVerify,
          usedRef: {
            username: info.usedRef?.username,
            publicAddress: info.usedRef?.publicAddress,
            picture: info.usedRef?.picture,
            refCode: info.usedRef?.refCode,
          },
        },
        accessToken: token ?? '',
        refreshToken: refreshToken ?? '',
        isOwallet: isOwalletParam === 'true' ? true : false,
      }));
    }
  }

  useEffect(() => {
    if (token && tokenExpiry && !accessTokenStr) {
      const tokenStorage = {
        value: token,
        expiry: Number(tokenExpiry),
      };
      
      localStorage.setItem('token', JSON.stringify(tokenStorage));
      handleGetInfoUser();
    }
  }, [token, tokenExpiry, accessTokenStr]);
  
  useEffect(() => {
    if (refreshToken && refreshTokenExpiry && !refreshTokenStr) {
      const tokenStorage = {
        value: refreshToken,
        expiry: Number(refreshTokenExpiry),
      };
    
      localStorage.setItem('refreshToken', JSON.stringify(tokenStorage));
    }
  }, [refreshToken, refreshTokenExpiry, refreshTokenStr]);
  
}

export default useLoginWithToken;